import * as React from 'react';
import { fetchCountryList } from '@gandi/redux-places';
import { useTranslator } from '@gandi/translate';
import { SelectField } from 'gandi.react-form';
import useCountries from '../hooks/useCountries';
import { jsx as _jsx } from "react/jsx-runtime";
function CountryField({
  defaultValue,
  ...inputProps
}) {
  const {
    __
  } = useTranslator();
  const {
    userCountries
  } = useCountries(defaultValue);
  const values = userCountries.map(country => ({
    text: country.name,
    value: country.alpha2
  }));
  return /*#__PURE__*/_jsx(SelectField, {
    label: __('Country'),
    name: "country",
    id: "country",
    placeholder: __('Select an item...'),
    values: values,
    variant: ['block'],
    ...inputProps
  });
}
CountryField.preFetch = function preFetch(args) {
  return args.dispatch(fetchCountryList());
};
export default CountryField;